import React, { createContext, SetStateAction, useEffect, useState } from 'react';

import { useTheme } from 'styled-components';

import { useMediaQuery } from '@mui/material';

export interface LayoutContentextValue {
  collapsed: boolean;
  onCollapse: React.Dispatch<SetStateAction<boolean>>;
}

const defaultValue: LayoutContentextValue = {
  collapsed: false,
  onCollapse: () => {}, // eslint-disable-line
};

export const LayoutContext = createContext<LayoutContentextValue>(defaultValue);

export const LayoutProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [collapsed, onCollapse] = useState<boolean>(false);
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.mediaQueries.down.lg);

  useEffect(() => {
    onCollapse(mobileView);
  }, [mobileView]);

  const value: LayoutContentextValue = {
    collapsed,
    onCollapse,
  };

  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
};
